import { useState } from "react";
import Button from "../../components/common/Button";
import Banner from "../../components/Landing/Banner";
import Section from "../../components/Landing/Section";
import YojanaSections from "../../components/Landing/YojanaSections";
import { INVEST_UK_WEBSITE_URL } from "../../config/apiConfig";
import {
  tifcFacilationSections,
  tifcFaciliationEligibility,
  yojanaBannerItems,
} from "../../config/homePageUtils";
import HomeLayout from "./HomeLayout";
import { useLanguage } from "../../components/LanguageProvider/LanguageProvider";

const TIFCFaciliation = () => {
  const { image, title, description } = yojanaBannerItems.tifcFaciliation;
  const [activeSection, setActiveSection] = useState("tifc-details");
  const { language } = useLanguage();
  return (
    <HomeLayout>
      <Banner
        image={image}
        title={title}
        description={description}
        language={language}
      />
      <YojanaSections
        options={tifcFacilationSections}
        activeSection={activeSection}
        setActiveSection={setActiveSection}
        language={language}
      >
        {activeSection === "tifc-details" && (
          <Section
            id="tifcDetails"
            title={
              language
                ? "पर्यटन निवेश सुविधा केंद्र (TIFC)"
                : "Tourism Investment Facilitation Centre (TIFC)"
            }
            openByDefault={true}
          >
            <ul className="list-unstyled space-y-3">
              <li className="d-flex align-items-start">
                <span className="text-[#018f9b] me-2 mt-1">●</span>
                <span>
                  {language
                    ? "राज्य सरकार द्वारा पर्यटन क्षेत्र में दी जाने वाली प्रोत्साहन और सब्सिडी का लाभ उठाने के इच्छुक निवेशकों को एकल खिड़की मंजूरी प्रणाली के तहत आवेदन करना होगा और परियोजना का पंजीकरण कराना होगा।"
                    : "The investors who wish to avail tourism sector incentives and subsidies of the state must apply and get the project registered with Single Window Clearance System"}
                  <Button
                    className="text-[#018f9b]"
                    onClick={() =>
                      window.open(
                        INVEST_UK_WEBSITE_URL,
                        "_blank",
                        "noopener,noreferrer",
                      )
                    }
                  >
                    {INVEST_UK_WEBSITE_URL}
                  </Button>
                </span>
              </li>
              {tifcFaciliationEligibility.map((item, idx) => (
                <li key={idx} className="d-flex align-items-start">
                  <span className="text-[#018f9b] me-2 mt-1">●</span>
                  <span>{language ? item.text.hi : item.text.en}</span>
                </li>
              ))}
              <li className="d-flex align-items-start">
                <span className="text-[#018f9b] me-2 mt-1">●</span>
                <span className="text-[#018f9b]">
                  tifcuttarakhandtourism [at] gmail [dot] com
                </span>
              </li>
            </ul>
          </Section>
        )}
      </YojanaSections>
    </HomeLayout>
  );
};

export default TIFCFaciliation;
